import GranosBox from "./granos/GranosBox";

const boxTypes = {
    "granos": GranosBox
};

export default boxTypes;